/**
 * The name of the bundled audio file which will be played for when live streaming is stopped.
 *
 * @type {string}
 */
// export const LIVE_STREAMING_OFF_SOUND_FILE = 'liveStreamingOff.mp3';
export const LIVE_STREAMING_OFF_SOUND_FILE = 'recordingOff.mp3';
/**
 * The name of the bundled audio file which will be played for when a live streaming is started.
 *
 * @type {string}
 */
// export const LIVE_STREAMING_ON_SOUND_FILE = 'liveStreamingOn.mp3';
export const LIVE_STREAMING_ON_SOUND_FILE = 'recordingOn.mp3';
/**
 * The name of the bundled audio file which will be played for when a recording is stopped.
 *
 * @type {string}
 */
export const RECORDING_OFF_SOUND_FILE = 'recordingOff.mp3';
/**
 * The name of the bundled audio file which will be played for when a recording is started.
 *
 * @type {string}
 */
export const RECORDING_ON_SOUND_FILE = 'recordingOn.mp3';
